module.exports = __webpack_public_path__ + "img/icon-ranking-1@2x.4146dc5d.png";